import { Tooltip, Box, Typography, Stack } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import { MEASURE_TYPES } from "../utils/constants";
import shouldFilterNullValues from "../utils/deviceFilterConfig";

function MeasureValueTooltip(props) {
  const { value, params } = props;
  const {
    row: { type, device },
    colDef: { valueGetter },
  } = params;
  const tooltipEntries = shouldFilterNullValues(device)
    ? Object.entries(value).filter(
        ([, val]) => val !== null && val !== undefined && val !== ""
      )
    : Object.entries(value);
  return (
    <Tooltip
      sx={{ width: 200 }}
      arrow
      title={
        <Box>
          {tooltipEntries.map(([field]) => {
            const measureTypeField =
              MEASURE_TYPES[type]?.fields[field.toLowerCase()];
            const name = measureTypeField?.label || field;
            const unit = measureTypeField?.unit || "";
            const displayValue = `${value[field]} ${unit}`;
            return (
              <Stack alignItems="center" direction="row" margin={0} key={field}>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    margin: "5px 0",
                    width: 200,
                    fontSize: "11px",
                  }}
                >
                  {name}:
                </Typography>
                <span>{displayValue}</span>
              </Stack>
            );
          })}
        </Box>
      }
    >
      <span
        style={{ width: 250, textOverflow: "ellipsis", overflow: "hidden" }}
      >
        {valueGetter?.(params) ?? JSON.stringify(value)}
      </span>
    </Tooltip>
  );
}

export default MeasureValueTooltip;

MeasureValueTooltip.propTypes = {
  params: PropTypes.shape().isRequired,
  value: PropTypes.shape().isRequired,
};
